import React from "react";
import { Navigate } from "react-router-dom";

interface PartnerRouteGuardProps {
  children: React.ReactNode;
}

const PartnerRouteGuard: React.FC<PartnerRouteGuardProps> = ({ children }) => {
  // Verificar se o parceiro está autenticado
  const partnerToken = localStorage.getItem("partnerToken");
  const partnerCompanyId = localStorage.getItem("partnerCompanyId");

  if (!partnerToken || !partnerCompanyId) {
    // Redirecionar para login unificado se não estiver autenticado
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default PartnerRouteGuard;
